import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Wrapper } from '@farewill/ui'

import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'

import { PRODUCTS } from 'lib/products/constants'

const SliceFAQ = (): React.ReactElement => {
  const { faqSection } = useStaticQuery<{
    faqSection: GatsbyTypes.ContentfulFaqSection
  }>(graphql`
    query {
      faqSection: contentfulFaqSection(
        contentful_id: { eq: "6JRDBr0Obg7i8SqBREbhtR" }
      ) {
        ...FaqSectionFields
      }
      guide: contentfulGuide(slug: { eq: "how-to-arrange-a-cremation" }) {
        slug
      }
    }
  `)

  /* Usually the title comes from the article on Contentful, however we don't want to rename
  the file on Contentful as it's being used in other places. 
  */
  const frequentlyAskedQuestionsTitle = 'Frequently asked questions'

  return (
    <Wrapper container containerPaddingBottom={0}>
      <FrequentlyAskedQuestions
        title={frequentlyAskedQuestionsTitle}
        questions={faqSection.questions}
        relatedGuide={faqSection.relatedGuide}
        selectedProduct={PRODUCTS.FUNERAL}
      />
    </Wrapper>
  )
}

export default SliceFAQ
